export default {
  setRecordDate (state: {[key:string]: string}, payload: string) {
    state.recordDate = payload
  },
  setGrouping (state: {[key:string]: number}, payload: number) {
    state.grouping = payload
  },
  setHasCamera (state: {[key:string]: boolean}, payload: boolean) {
    state.hasCamera = payload
  },
  setHasPlanting (state: {[key:string]: boolean}, payload: boolean) {
    state.hasPlanting = payload
  },
  setImgSize (state: {[key:string]: string}, payload: string) {
    state.imgSize = payload
  }
}
